import { type Client, type RouteGenerator, RouteInfo } from "silver";

export class PageState<T extends object> {

	private readonly proxy: T;
	private data: T;

	constructor(
		private defaultState: T,
		private client: Client,
		private router: RouteGenerator
	) {
		const routeParams = (this.router.routeFromPathInfo(this.client.url).parameters) as unknown as Partial<T>;
		this.data = { ...defaultState, ...routeParams };
		this.proxy = new Proxy({ }, {
			get: (target: any, key: string | symbol): T[keyof T]|undefined => {
				return this.data[key as keyof T];
			},
			set: (target: any, key: string | symbol, value: any): boolean => {
				if (!(key in this.data)) {
					return false;
				}
				this.data[key as keyof T] = value;
				this.updateURL();
				return true;
			}
		});
	}

	private updateURL(): void {
		const route = this.router.routeFromPathInfo(this.client.url);
		const cleanState = { ...route.parameters };
		(Object.entries(this.data) as Array<[string & keyof T, string|number]>).forEach(([key, value]) => {
			if (this.data[key] === this.defaultState[key]) {
				delete cleanState[key];
			} else {
				cleanState[key] = value;
			}
		});
		const nextRoute = new RouteInfo(route.path, route.action, cleanState, route.extension);
		window.history.replaceState({ }, "", this.router.routeInfoToPath(nextRoute));
	}

	get state(): T {
		return this.proxy;
	}

	set state(state: T) {
		this.data = state;
		this.updateURL();
	}
}
